import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { getNewsAndEventsDetailRequest, getNewsAndEventsDetailRequestError, getNewsAndEventsDetailRequestSuccess } from "../../slices/NewsAndEvents/DetailSlice";

export const GetNewsAndEventsDetailApi = (id) => async (dispatch) => {
    const urlWithParams = `${endpoints.newsAndEventsDetail}/${id}`;

    try {
        dispatch(getNewsAndEventsDetailRequest());
        axiosInstance({
            method: "GET",
            url: urlWithParams,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getNewsAndEventsDetailRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getNewsAndEventsDetailRequestError(_error));
            });
    } catch (error) {
    }
};
